import React, { Component } from 'react';
import { string, func, object, bool, array } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import {
  actions,
  getCallbackEndpoint,
  getPayment2C2PEndpoint,
  getHashValue,
  getBanks,
} from '@dragonfruit/redux/purchase/checkout2C2P';
import { getToken } from '@dragonfruit/redux/auth';
import { hideAlertBanner } from '@dragonfruit/redux/alertBanner';

import styles from './PayBy2C2P.scss';
const cx = require('classnames/bind').bind(styles);

const mapStateToProps = state => ({
  callbackEndpoint: getCallbackEndpoint(state),
  hashValue: getHashValue(state),
  payment2C2PEndpoint: getPayment2C2PEndpoint(state),
  isLoggedIn: !!getToken(state),
  banks: getBanks(state),
});

class PayBy2C2P extends Component {
  static propTypes = {
    banks: array.isRequired,
    callbackEndpoint: string.isRequired,
    get2C2PBanks: func.isRequired,
    hashValue: string.isRequired,
    hideAlertBanner: func.isRequired,
    isLoggedIn: bool.isRequired,
    payment2C2PEndpoint: string.isRequired,
    reset2C2PHash: func.isRequired,
    reset2C2PInfo: func.isRequired,
    selectedPayment: object.isRequired,
    selectedPlan: object.isRequired,
    setReadyToSubmit: func.isRequired,
    t: func.isRequired,
    triggerSubmit: bool.isRequired,
    onPaymentSubmit: func.isRequired,
  };

  state = {
    selectedAgentCode: '',
  };

  componentDidMount() {
    const { get2C2PBanks, setReadyToSubmit } = this.props;
    get2C2PBanks();
    setReadyToSubmit(false);
  }

  componentDidUpdate = prevProps => {
    const { triggerSubmit, hashValue, reset2C2PHash } = this.props;

    if (hashValue) {
      document.getElementById('2c2pSubmitBtn').click();
      reset2C2PHash();
    }
    if (triggerSubmit !== prevProps.triggerSubmit && triggerSubmit) {
      this.onCheckout();
    }
  };

  componentWillUnmount() {
    const { reset2C2PInfo, hideAlertBanner } = this.props;
    reset2C2PInfo();
    hideAlertBanner();
  }

  onCheckout = () => {
    const {
      selectedPayment: { price, sku, id: paymentMethodId },
      selectedPlan: {
        id: planId,
        name,
        currency,
        planType,
        sellingTypes,
        questionQuota,
      },
      onPaymentSubmit,
    } = this.props;

    const { selectedAgentCode } = this.state;

    onPaymentSubmit({
      paymentMethodId,
      agentCode: selectedAgentCode,
      gtmData: {
        // The data below comes from selectedPlan object.
        planId,
        name,
        planType,
        sellingTypes,
        questionQuota,
        currency,
        // The data below comes from paymentMethod object in the plan.
        sku,
        price,
      },
    });
  };

  handleSelectBank = id => () => {
    const { setReadyToSubmit } = this.props;
    this.setState({ selectedAgentCode: id });
    setReadyToSubmit(true);
  };

  render() {
    const { t, payment2C2PEndpoint, hashValue, banks } = this.props;
    const { selectedAgentCode } = this.state;

    return (
      <div className={styles.root}>
        <div className={styles.paymentInfo}>
          <h6 className={styles.paymentTitle}>
            {t('purchase.payBy2C2P.introduction.mobileBanking.title')}
          </h6>
          <ol className={styles.bankingTextList}>
            <li>{t('purchase.payBy2C2P.introduction.mobileBanking.step1')}</li>
            <li>{t('purchase.payBy2C2P.introduction.mobileBanking.step2')}</li>
            <li>{t('purchase.payBy2C2P.introduction.mobileBanking.step3')}</li>
            <li>{t('purchase.payBy2C2P.introduction.mobileBanking.step4')}</li>
          </ol>
          <p
            className={styles.details}
            dangerouslySetInnerHTML={{
              __html: `${t(
                'purchase.payBy2C2P.introduction.mobileBanking.details'
              )}`,
            }}
          />
        </div>

        <div className={styles.bankList}>
          {banks.map(bank => (
            <div
              key={bank.id}
              className={cx('backListItem', {
                active: bank.agentCode === selectedAgentCode,
              })}
              onClick={this.handleSelectBank(bank.agentCode)}
            >
              <img src={bank.logoUrl} className={styles.bankLogoImage} />
            </div>
          ))}
        </div>

        <form method="post" action={payment2C2PEndpoint} target="_blank">
          <input
            type="hidden"
            name="paymentRequest"
            id="hash_value"
            value={hashValue}
          />
          <input type="submit" className={styles.hide} id="2c2pSubmitBtn" />
        </form>
      </div>
    );
  }
}

export default compose(
  translate('purchase'),
  connect(mapStateToProps, {
    get2C2PBanks: actions.get2C2PBanks,
    reset2C2PInfo: actions.reset2C2PInfo,
    reset2C2PHash: actions.reset2C2PHash,
    hideAlertBanner,
  })
)(PayBy2C2P);



// WEBPACK FOOTER //
// ./app/components/PaymentHandler/PayBy2C2P/PayBy2C2P.jsx